import { render, staticRenderFns } from "./WritePage.vue?vue&type=template&id=66d0c80c&scoped=true&"
import script from "./WritePage.vue?vue&type=script&lang=js&"
export * from "./WritePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d0c80c",
  null
  
)

export default component.exports